import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'


@Component({
  selector: 'app-history-details',
  templateUrl: './history-details.component.html',
  styleUrls: ['./history-details.component.css']
})
export class HistoryDetailsComponent implements OnInit {

  historyDetailsForm = this
  .formBuilder
  .group({
    name: [
      '', Validators.required
    ],
    email: [
      '', Validators.required
    ],
    fax_number: [
      '', Validators.required
    ],
    main_number: [
      '', Validators.required
    ],
   
  });

  public historyDetails;
  public isReadonly = false


  constructor(public dialogRef: MatDialogRef<HistoryDetailsComponent>,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService : CommonService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any


    ) {
      this.historyDetails = data.id.location;
     }

  ngOnInit(): void {

    // this.historyDetailsForm.setValue({
    //   name :this.historyDetails.name,
    //   email: this.historyDetails.email,
    //   fax_number: this.historyDetails.fax_number,
    //   main_number: this.historyDetails.main_number,
   
    // })


  }


}
